import player from './player'
import equipment from './equipment'
import avatar from './avatar'
import jobs from './jobs'
import box from './box'
import missions from './missions'
import sweethearts from './sweethearts'
import report from './report'
import guard from '@/stores/sorority-wars/guard'
import boosts from '@/stores/sorority-wars/boosts'
import bosses from '@/stores/sorority-wars/bosses'
import tailors from '@/stores/sorority-wars/tailors'

const modules = {
  player,
  equipment,
  avatar,
  guard,
  jobs,
  box,
  missions,
  sweethearts,
  report,
  boosts,
  bosses,
  tailors
}

export default { modules }
